import { getResourceUrl } from "./getResourceUrl";
import { ConfigContainerChild } from "../types";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

export const getSvgUrl = ({
  element,
  layerInfo,
  attributes,
}: {
  element: ConfigContainerChild;
  layerInfo: LayerInfo;
  attributes: FeatureAttribute[];
}) => {
  let url = "";

  if (element.attributeIcon && layerInfo.layerAttributes) {
    const iconAttribute = layerInfo.layerAttributes.find(
      ({ attributeName }) => attributeName === element.attributeIcon,
    )?.icon;

    url = iconAttribute?.resourceId || iconAttribute?.url;
  } else {
    url = element.attributeName
      ? attributes?.find(item => item.name === element.attributeName)?.value?.toString()
      : element.value?.toString();
  }

  if (!url || typeof url !== "string") return null;

  return getResourceUrl(url);
};
